import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { logout } from '../../services/authentication';
import { CommonDropdown } from '../common/UI/CommonDropdown';
import { menuConfig } from './menuConfig';
import { CommonDropdownProps } from '../common/UI/CommonDropdown';
import { AppContext } from '@/context/AppContext';

export const ProfileMenu = () => {
  const navigate = useNavigate();
  const { allowedRoutes = [] } = useContext(AppContext);
  const { userInitials = '' } = useContext(AuthContext);

  const isDashboardRouteAllowed = allowedRoutes?.includes('/dashboard');
  const isSandboxRouteAllowed = allowedRoutes?.includes('/sandbox');

  const config = menuConfig(
    navigate,
    logout,
    userInitials,
    isSandboxRouteAllowed,
    isDashboardRouteAllowed
  );

  return (
    <div className="profile-menu">
      {Object.values(config)
        .filter((item): item is CommonDropdownProps => !!item)
        .map((menuProps, idx) => (
          <CommonDropdown key={idx} {...menuProps} />
        ))}
    </div>
  );
};
